/// <reference types="@types/googlemaps" />
import { Injectable } from '@angular/core';
import { WindowRef, DocumentRef } from './utils.service';
import { environment } from '../../../../environments/environment';

@Injectable()
export class GoogleMapsService {

  protected mapLoadingPromise: Promise<boolean>;
  protected readonly mapScriptId: string = 'tpsGoogleMaps';
  protected readonly callbackName: string = 'tpsGoogleMapsCallback';

  constructor(protected windowRef: WindowRef, protected documentRef: DocumentRef) {}

  load(): Promise<boolean> {
    const window = this.windowRef.window;
    if (window.google && window.google.maps) {
      // Google maps already loaded on the page.
      return Promise.resolve(true);
    }

    if (this.mapLoadingPromise) {
      return this.mapLoadingPromise;
    }

    const scriptOnPage = this.documentRef.document.getElementById(this.mapScriptId);
    if (scriptOnPage) {
      this.assignScriptLoadingPromise(scriptOnPage);
      return this.mapLoadingPromise;
    }

    const script = this.documentRef.document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.id = this.mapScriptId;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&callback=${this.callbackName}&libraries=geometry,places`;
    this.assignScriptLoadingPromise(script);
    this.documentRef.document.body.appendChild(script);

    return this.mapLoadingPromise;
  }

  get baseSettings(): google.maps.MapOptions {
    return Object.assign({}, {
      zoom: 15,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      minZoom: 3,
      maxZoom: 20
    });
  }

  private assignScriptLoadingPromise(scriptElem: HTMLElement) {
    this.mapLoadingPromise = new Promise<boolean>((resolve: Function, reject: Function) => {
      (<any>this.windowRef.window)[this.callbackName] = () => {
        resolve();
      };

      scriptElem.onerror = (error: Event) => {
        reject(error);
      };
    });
  }
}
